import type {
  AreaCharge,
  CreateAreaChargeDto,
  UpdateAreaChargeDto,
} from '@carvia/ros-client-types';
import { Service } from './http-service';

class AreaChargesService extends Service<AreaCharge, CreateAreaChargeDto, UpdateAreaChargeDto> {}

export const areaChargesService = new AreaChargesService('/area-charges');
